import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Cool thing thursday: Pocket.co - feed your inner internetovore, keep your browser happy",
  "description": "",
  "published": "2012-11-01T00:00:00.000Z",
  "redirect_from": ["/blog/cool-thing-thursday-pocket-co-feed-your-inner-internetovore-keep-your-browser-happy/swizec/5482"],
  "categories": "Google Chrome, IOS, IPhone, Mac OS, Read It Later, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A few years ago I tried `}<em parentName="p"><a parentName="em" {...{
          "href": "http://readitlaterlist.com",
          "title": "Read It Later"
        }}>{`Read It Later`}</a></em>{` - a browser bookmarklet that let you defer reading long articles. When you discovered something you really wanted to read but didn't have immediately, you could just store it for later.`}</p>
    <p>{`Imagine what happens next. Most of the articles languish, never to be opened again. After a few months I stopped using the service.`}</p>
    <p>{`But! I never stopped using the behaviour.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/11/ipad-pocket.png",
        "alt": "Pocket on iPad",
        "title": "Pocket on iPad"
      }}></img><img parentName="p" {...{
        "src": "",
        "alt": null
      }}></img><img parentName="p" {...{
        "src": "",
        "alt": null
      }}></img></p>
    <p>{`As a voracious internetovore, the fearsome bane of unread content everywhere, I kept clicking every link with a semi-interesting headline I could get my grubby little paws on. Be it image, video or a metric fucktonne of text - I would open it.`}</p>
    <p>{`Then realize I don't have time to read it.`}</p>
    <p>{`Then keep it open for three hours.`}</p>
    <p>{`A day.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/11/iphone-pocket.png",
        "alt": "Pocket on iPhone",
        "title": "Pocket on iPhone"
      }}></img></p>
    <p>{`A week.`}</p>
    <p>{`Then my browser session crept up to fifty tabs spread over three windows ... on each computer (laptop+desktop). Things got slow, most of my RAM was on a hard drive and life was anything but ideal. Far from even remotely pleasant.`}</p>
    <p>{`A while ago I rediscovered Read it Later, now rebranded as `}<em parentName="p">{`Pocket`}</em>{` and awesomer than ever.`}</p>
    <p>{`No longer a bookmarklet, but a full-fledged `}<a parentName="p" {...{
        "href": "http://www.google.com/chrome",
        "title": "Google Chrome"
      }}>{`Chrome`}</a>{` plugin with companion apps for both iPad and iPhone. Much shinier and friendlier than it used to be, there was now even a very useful html5'd website for my reading pleasure.`}</p>
    <p>{`Last week they even released a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Mac_OS",
        "title": "Mac OS"
      }}>{`MacOS`}</a>{` app.`}</p>
    <p>{`Of course I still don't read most of the articles I save. The queue is still growing relentlessly, far quicker than I could read anything. But that's not the point. I've come to terms with the fact that Pocket is a tool for keeping memory usage low and browsers happy.`}</p>
    <p>{`No longer do I store everything in forever-tabs. Push it to Pocket so it's out of mind, out of worry and out of RAM. Sometimes I'll actually get around to reading it, most often not. But at least both my inner internetovore and minimalist side are happy.`}</p>
    <p>{`As an added bonus, Pocket is `}<strong parentName="p">{`magnificent`}</strong>{` for easily sharing links between devices. Win!`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/11/pocket-macos-readability-1024x789.png",
        "alt": "Pocket on MacOS with a cleaned up page",
        "title": "Pocket on MacOS with a cleaned up page"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/11/pocket-macos-raw+sharing-1024x741.png",
        "alt": "Pocket on MacOS with native page and sharing widget",
        "title": "Pocket on MacOS with native page and sharing widget"
      }}></img></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.macworld.com/article/2012651/stay-on-top-of-the-web-with-read-later-services.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/120349931_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.macworld.com/article/2012651/stay-on-top-of-the-web-with-read-later-services.html"
        }}>{`Stay on top of the Web with read-later services`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.tuaw.com/2012/10/25/pocket-for-mac-joins-the-pocket-family/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/121252389_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.tuaw.com/2012/10/25/pocket-for-mac-joins-the-pocket-family/"
        }}>{`Pocket for Mac joins the Pocket family`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.cultofmac.com/198043/brand-new-today-pocket-for-mac/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/121140730_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.cultofmac.com/198043/brand-new-today-pocket-for-mac/"
        }}>{`Brand New Today: Pocket For Mac`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://gravitationalpull.net/wp/?p=2160"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_11_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://gravitationalpull.net/wp/?p=2160"
        }}>{`Instapaper isn't Instaworth it anymore - switching to Pocket`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.cultofmac.com/198122/simple-slick-superb-pocket-for-mac-does-save-for-later-right-review/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/121197633_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.cultofmac.com/198122/simple-slick-superb-pocket-for-mac-does-save-for-later-right-review/"
        }}>{`Simple, Slick, Superb: Pocket For Mac Does Save-For-Later Right `}{`[`}{`Review`}{`]`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=dd2057a5-b88f-4b93-a282-f97333d67ca5",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      